<script lang="ts">
    import { appManager } from "../../AppManager";
    import type { LayerManager } from "./LayerManager";

    export let manager: LayerManager;

    let visible = manager.getVisibleStore();
    let vehicle = manager.getVehicle();
    let name = manager.getName();
    let properties = manager.getProperties();

    let visibleVehicles = manager.getVisibleVehiclesStore();

    let hiddenAsVehicle = !$visibleVehicles.has(vehicle.id);
    $: {
        hiddenAsVehicle = !$visibleVehicles.has(vehicle.id);
    }
</script>

<!-- {#if !hiddenAsVehicle} -->
<li class="list-group-item d-flex px-1 py-0 cursor-default li-hover {hiddenAsVehicle ? 'disabled' : ''}">
    <div class="form-check form-switch">
        <input
            class="form-check-input"
            type="checkbox"
            disabled={hiddenAsVehicle}
            bind:checked={$visible}/>
    </div>
    <div class="pb-1 container-badge">
        <img
            src="{appManager.PublicUrl}icons/vehicles/{vehicle.logo}.svg"
            alt={vehicle.name} />
    </div>
    <div class="list-link ps-1 pe-2 d-flex flex-column align-items-start">
        <div>
            {name}
        </div>
        <div class="text-muted h6 list">
            {#if properties?.description !== undefined}
                <div>
                    {properties?.description ?? ""}
                </div>
            {/if}
            <div>
                {properties?.source ?? ""}
                {properties?.sourcedate ?? ""}
            </div>
            {#if properties?.routeplanningdate !== undefined}
                <div>
                    Routes were generated on {properties
                        .routeplanningdate}
                </div>
            {/if}
        </div>
    </div>
</li>
<!-- {/if} -->

<style>
    img {
        width: 20px;
        height: 20px;
    }
</style>
